var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('i',{staticClass:"fa fa-3x fa-cog fa-spin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }